import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const JenisPrestasiService = {}
JenisPrestasiService.getDataAll = function (token) {

    return fetch({
        url: '/ref/jenis_prestasi',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

JenisPrestasiService.getDataByID = function (token,id) {

    return fetch({
        url: '/ref/jenis_prestasi',
        method: 'get',
        params: {
            "id_jenis_prestasi":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default JenisPrestasiService;
